export default __webpack_public_path__ + "static/media/stars.606718b7.jpg";